import Timer from "../utils/Timer.ts";

export default class DelayData {
    public callback: () => void;
    public id: string;
    public params: string[];
    public timer: Timer;
}
